// BM_COLORS_POPULAR: curated top-150 best-selling Benjamin Moore colours
// Source: Decor Fusion (BenjaminMooreCorporateReporting), last 3 years of sales, ranked by times sold.
// Used as the default color-picker view for performance; full catalog remains searchable.
window.BM_COLORS_POPULAR = [
  ['White Dove', 'OC-17', '#efeee5', 'White'],
  ['Chantilly Lace', '2121-70', '#f5f7f2', 'White'],
  ['Simply White', '2143-70', '#f7f7ee', 'White'],
  ['Swiss Coffee', 'OC-45', '#eeece1', 'White'],
  ['Cloud White', 'CC-40', '#f3f2e7', 'White'],
  ['Oxford White', 'CC-30', '#f1f2eb', 'White'],
  ['Revere Pewter', 'HC-172', '#ccc7b9', 'Neutral'],
  ['Pale Oak', 'OC-20', '#ddd9ce', 'Neutral'],
  ['Classic Gray', '1548', '#e4e1d8', 'White'],
  ['Cloud White', 'OC-130', '#f3f2e7', 'White'],
  ['Dove Wing', '960', '#eae7dc', 'White'],
  ['Balboa Mist', 'OC-27', '#dbd7cd', 'Neutral'],
  ['Edgecomb Gray', 'HC-173', '#dad4c5', 'Neutral'],
  ['Cloud Cover', 'OC-25', '#eae7de', 'White'],
  ['Decorators White', 'CC-20', '#eceeeb', 'White'],
  ['Gray Owl', 'OC-52', '#d3d4cc', 'Gray'],
  ['Seapearl', '961', '#e8e5da', 'White'],
  ['Silver Satin', '856', '#e4e3db', 'White'],
  ['Wrought Iron', '2124-10', '#4a4b4c', 'Gray'],
  ['Black', '2132-10', '#323233', 'Black'],
  ['Hale Navy', 'HC-154', '#444c57', 'Blue'],
  ['Kendall Charcoal', 'HC-166', '#686763', 'Gray'],
  ['Natural Cream', 'OC-14', '#dbd6c7', 'White'],
  ['Black Forest', 'HC-190', '#323233', 'Black'],
  ['Collingwood', '859', '#d4cfc5', 'Neutral'],
  ['Calm', '2111-70', '#e7e5e0', 'White'],
  ['Onyx', '2133-10', '#363535', 'Gray'],
  ['Steam', 'AF-15', '#f1f0e7', 'White'],
  ['Stonington Gray', 'HC-170', '#cbccc6', 'Gray'],
  ['Ballet White', 'OC-9', '#e5ded0', 'White'],
  ['Van Deusen Blue', 'HC-156', '#495c6f', 'Blue'],
  ['Super White', 'OC-152', '#f1f2ee', 'White'],
  ['Saybrook Sage', 'HC-114', '#b2b8a3', 'Green'],
  ['Winds Breath', '981', '#e0dcce', 'Neutral'],
  ['Vintage Vogue', '462', '#575e50', 'Gray'],
  ['October Mist', 'CC-550', '#b7b9a6', 'Green'],
  ['Snowfall White', '2144-70', '#f7f8ef', 'White'],
  ['Baby Fawn', 'OC-15', '#d9d0c1', 'Neutral'],
  ['Coventry Gray', 'HC-169', '#b9bbb7', 'Gray'],
  ['Essex Green', 'HC-188', '#28372f', 'Black'],
  ['Newburyport Blue', 'HC-155', '#475667', 'Blue'],
  ['Pashmina', 'AF-100', '#bcb3a2', 'Neutral'],
  ['Vanilla Milkshake', '2141-70', '#edede4', 'White'],
  ['Distant Gray', '2124-70', '#f3f5f2', 'White'],
  ['Gray Mist', '962', '#e4e0d3', 'White'],
  ['Cotton Balls', '2145-70', '#f6f7ec', 'White'],
  ['Chelsea Gray', 'HC-168', '#87857d', 'Gray'],
  ['Mountain Peak White', '2148-70', '#f8f6ec', 'Yellow'],
  ['Soft Chamois', '969', '#e9e6d9', 'White'],
  ['Mascarpone', 'AF-20', '#f9f8e9', 'Yellow'],
  ['Black Beauty', '2128-10', '#3a3837', 'Gray'],
  ['Glacier White', 'OC-37', '#eceae0', 'White'],
  ['White Heron', 'OC-57', '#f0f1ea', 'White'],
  ['Platinum Gray', 'HC-179', '#a9aaa4', 'Gray'],
  ['Elmira White', 'HC-84', '#dcd4c4', 'Neutral'],
  ['Cinnamon Slate', '2113-40', '#8a7576', 'Gray'],
  ['Paper White', '1590', '#e1e3dd', 'White'],
  ['Intense White', 'OC-51', '#dedbd6', 'White'],
  ['White Diamond', '2121-60', '#edf0ed', 'White'],
  ['Pure White', 'OC-64', '#e6e8e2', 'White'],
  ['Navajo White', '947', '#efe8d6', 'White'],
  ['Floral White', 'OC-29', '#edebdd', 'White'],
  ['Gentlemans Gray', '2062-20', '#314757', 'Blue'],
  ['Stone Harbor', 'CC-490', '#c5bbab', 'Neutral'],
  ['Frostine', 'AF-5', '#eff2ec', 'White'],
  ['Iron Mountain', '2134-30', '#585654', 'Gray'],
  ['Boreal Forest', 'AF-480', '#54604f', 'Green'],
  ['Thunder', 'AF-685', '#beb9ae', 'Neutral'],
  ['White Opulence', '879', '#f6f3ee', 'White'],
  ['Acadia White', 'OC-38', '#f2edde', 'White'],
  ['Wickham Gray', 'HC-171', '#d5d9d3', 'Gray'],
  ['White Down', '970', '#ece7d8', 'White'],
  ['Silhouette', 'AF-655', '#58514d', 'Gray'],
  ['Jet Black', '2120-10', '#343435', 'Gray'],
  ['Gray Cloud', '2126-60', '#d8dddf', 'White'],
  ['Inukshuk', 'CC-460', '#cec5b6', 'Neutral'],
  ['Natural Linen', 'CC-90', '#d8ceb8', 'Neutral'],
  ['Mayonnaise', '2152-70', '#faf6e6', 'Yellow'],
  ['White Wisp', '2137-70', '#e7e9e2', 'White'],
  ['Amherst Gray', 'HC-167', '#767771', 'Gray'],
  ['Louisburg Green', 'HC-113', '#9d9f88', 'Green'],
  ['Dune White', 'CC-70', '#edebe1', 'White'],
  ['Fossil', 'AF-65', '#e4decf', 'White'],
  ['Soft Fern', '2144-40', '#c9cbb3', 'Neutral'],
  ['Black Ink', '2127-20', '#383b3e', 'Gray'],
  ['Black Iron', '2120-20', '#3b3d3f', 'Gray'],
  ['Oxford Brown', 'ES-67', '#4f423b', 'Brown'],
  ['Manchester Tan', 'HC-81', '#dcd3bd', 'Yellow'],
  ['Decorators White', 'OC-149', '#eceeeb', 'White'],
  ['Black Panther', '2125-10', '#3e4041', 'Gray'],
  ['Abalone', '2108-60', '#d4d0c8', 'Neutral'],
  ['Lush', 'AF-475', '#748172', 'Gray'],
  ['Collectors Item', 'AF-45', '#f2ebdd', 'White'],
  ['Dark Olive', '2140-30', '#626354', 'Gray'],
  ['Black Satin', '2131-10', '#323536', 'Gray'],
  ['China White', 'OC-141', '#e7e4d9', 'White'],
  ['Moonshine', '2140-60', '#d7d9d0', 'Green'],
  ['White Sand', '964', '#e1d9c7', 'Yellow'],
  ['Palladian Blue', 'HC-144', '#c2d2ca', 'Green'],
  ['Van Courtland Blue', 'HC-145', '#87999f', 'Blue'],
  ['Black Forest Green', 'HC-187', '#252f2d', 'Black'],
  ['Rockport Gray', 'HC-105', '#a9a396', 'Neutral'],
  ['Feather Down', '953', '#e7e1d0', 'White'],
  ['Titanium', '2141-60', '#dbdcd0', 'Green'],
  ['Snow White', '2122-70', '#f2f6f2', 'White'],
  ['Gray Owl', '2137-60', '#d4d5cd', 'Gray'],
  ['High Park', 'CC-620', '#8d9a86', 'Green'],
  ['Ranchwood', 'CC-500', '#aea391', 'Neutral'],
  ['Cement Gray', '2112-60', '#cecdcb', 'Gray'],
  ['Horizon', '1478', '#e0e2dc', 'White'],
  ['Fog Mist', 'OC-31', '#e1dbcf', 'Neutral'],
  ['Natural Wicker', '950', '#e8dfcb', 'White'],
  ['Maritime White', '963', '#e6dfcf', 'White'],
  ['Timid White', '2148-60', '#f3efde', 'Yellow'],
  ['Sea Salt', 'CSP-95', '#d5d0c4', 'Neutral'],
  ['Misty Gray', '2124-60', '#e9eceb', 'White'],
  ['Jojoba', 'AF-460', '#868b75', 'Gray'],
  ['Vapor', 'AF-35', '#f0ede0', 'White'],
  ['Mysterious', 'AF-565', '#464c55', 'Blue'],
  ['Silken Pine', '2144-50', '#e1e4d5', 'White'],
  ['Rosepine', '461', '#747f6c', 'Gray'],
  ['Gray Timber Wolf', '2126-50', '#bbc2c7', 'Blue'],
  ['Red', '2000-10', '#ca2f2f', 'Red'],
  ['Peale Green', 'HC-121', '#596b55', 'Green'],
  ['Monterey White', 'HC-27', '#eae6d1', 'White'],
  ['Heritage Red', 'HC-181', '#9a0b15', 'Brown'],
  ['White', 'OC-151', '#edeeeb', 'White'],
  ['Creamy White', 'OC-7', '#e4d9c7', 'White'],
  ['French Canvas', '1514', '#e6e4d5', 'White'],
  ['Seashell', '926', '#edead9', 'White'],
  ['Salamander', '2050-10', '#303f3f', 'Blue'],
  ['Hunter Green', '2041-10', '#2b463e', 'Green'],
  ['Flint', 'AF-560', '#575d5f', 'Gray'],
  ['White Down', 'CC-50', '#ece7d8', 'White'],
  ['Forest Floor', 'CC-570', '#636552', 'Green'],
  ['Topsoil', 'CC-692', '#43493f', 'Gray'],
  ['Evening Dove', '2128-30', '#525b68', 'Blue'],
  ['Old Navy', '2063-10', '#2f364a', 'Blue'],
  ['Mystical Grape', '2071-30', '#674c87', 'Purple'],
  ['October Mist', '1495', '#b7b9a6', 'Green'],
  ['Muslin', '1037', '#e2d7c2', 'Yellow'],
  ['Moonlight White', '2143-60', '#f0efe4', 'White'],
  ['Sand Dollar', '877', '#f1ece5', 'White'],
  ['Briarwood', 'HC-175', '#a1998a', 'Neutral'],
  ['Cushing Green', 'HC-125', '#697767', 'Gray'],
  ['Yarmouth Blue', 'HC-150', '#b6c9ca', 'Blue'],
  ['Babys Breath', '873', '#ebede9', 'White'],
  ['Ashwood Moss', '1484', '#575952', 'Gray'],
  ['Dark Pewter', '2122-10', '#4c5857', 'Gray']
];
